import { render, staticRenderFns } from "./MyContent.vue?vue&type=template&id=3f8b1e1c&scoped=true&"
import script from "./MyContent.vue?vue&type=script&lang=js&"
export * from "./MyContent.vue?vue&type=script&lang=js&"
import style0 from "./MyContent.vue?vue&type=style&index=0&id=3f8b1e1c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8b1e1c",
  null
  
)

export default component.exports